import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { orgPeopleList } from '../organization-people-list';
import { get_people_ud_path } from 'ze-api-contract/people-v2/crud-people';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useUpdatePeople() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { organizationId, peopleId, data } = param;
            return axios.post(get_people_ud_path({
                id: peopleId,
                organization: organizationId
            }), data);
        },
        onSuccess: async (res, param)=>{
            let { organizationId } = param;
            await queryClient.invalidateQueries({
                queryKey: orgPeopleList.peopleList({
                    organization: organizationId
                }).queryKey
            });
        }
    });
}
